import MomentUtils from "@date-io/moment";
import { Button, CircularProgress, Fade, FormControl, Grid, InputLabel, MenuItem, OutlinedInput, Paper, Select, Table, TableBody, TableCell, TableRow, Typography, withStyles } from "@material-ui/core";
import { blue, red } from '@material-ui/core/colors';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import React, { Component } from "react";
import 'react-day-picker/lib/style.css';
import AutoCompleteSelection from "../components/AutoCompleteSelection_v2";
import EnhancedTableHead from "../components/EnhancedTableHead";
import EnhancedTableToolbar from "../components/EnhancedTableToolbar";
import "../css/inventory_transactions.css";
import { ProductService } from "../Services/ProductService";
import { WarehouseService } from "../Services/WarehouseService";
import { format_fancy_notime, format_without_time, getTimeInIST } from '../Utils';
import XLSX from 'xlsx';

const styles = theme =>({
    appBar: {
        position: 'relative',
        marginBottom: 10
    },

    fab: {
        margin: theme.spacing(1),
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        position: 'fixed', 
        zIndex: 2
    },
    
    root: {
        width: '100%',
        overflowX: 'auto',
        paddingTop : theme.spacing(1), 
        paddingLeft: theme.spacing(1), 
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    qtyField: {
        width: "40%",
        position: "relative",
        [theme.breakpoints.up('md')]: {
            right: '100px',
            width: "10%",
            marginRight: 10
        },
        right: "22px"
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    grid: {
        [theme.breakpoints.up('md')]: {
            marginTop: '10px',
        },
        marginTop: '50px',
        marginBottom: '5px'
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    icon: {
        padding: '0px',
        [theme.breakpoints.up('md')]: {
            padding: '12px',
        },
    },
    txn_details: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        float: "right",
        marginRight: theme.spacing(4)
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(1),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
        },
    },
    formControlLeft: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(4),
        },
    },
    card: {
        maxWidth: 600,
        minWidth: 300,
        minHeight: 184,
        margin: 5
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    actions: {
        display: 'flex',
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    tablecell: {
        fontSize: '12pt',
        padding: theme.spacing(2)
    },
    container: {
        paddingTop : theme.spacing(1)
    },
    redAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: red[500],
    },
    blueAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: blue[500],
    },
    formControlAutoComplete: {
        zIndex: 2,
        margin: theme.spacing(1),
        minWidth: 200,
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
        },
    },
    row: {
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.background.default,
        },
    },
    instructions: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },
    button: {
        marginTop: theme.spacing(3),
        height: theme.spacing(7),
        float: 'left',
        marginLeft: theme.spacing(2),
    }, 
    tableWrapper: {
        height: 407,
        overflow: 'auto',
    },
    list: {
        width: '100%',
        height: 250,
        overflow: "auto"
    },
    summary: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    typography: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    details: {
        alignItems: 'center',
    },
    columnFilter: {
        marginTop: 5,
        flexBasis: '5%',
    },
    column: {
        flexBasis: '100%',
    },
    helper: {
        borderLeft: `2px solid ${theme.palette.divider}`,
        padding: theme.spacing(1, 2),
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    heading: {
        fontSize: theme.typography.pxToRem(18),
    }
});

class OpeningStockReport extends Component {

    constructor(props) {
      super(props);
      this.state = {
        startdate : moment().add(-1, 'day'),
        enddate: moment(),
        current_rows: [],
        columns : [
            // { id: 'index', numeric: false, disablePadding: true, label: 'Sl. No', sortable: false },
            { id: 'txn_date', numeric: false, disablePadding: true, label: 'Date', sortable: false },
            { id: 'opening', numeric: false, disablePadding: true, label: 'Opening Stock', sortable: false  },
            { id: 'closing', numeric: false, disablePadding: true, label: 'Closing Stock', sortable: false  },
        ],
        order: "asc",
        orderBy: "txn_date",
        master_products: [],
        master_source: [],
        selected_source: "",
        selected_product: {},
        product_name_rows: [],
        loading: false,
        exporting: false
      }
    }

    componentDidMount(){
        this.fetchMasterData();
        this.props.setTitle('Opening Stock Report');
    }

    fetchMasterData = () => {
        this.fetchProductsFilter();
        this.fetchSourcesFilter();
    }

    fetchProductsFilter = () => {
        ProductService.getProductList()
        .then((data) => {
            let product_name_rows = data.products.filter(p => p.status !== -1).map((element) =>( 
                ({id: element.id, name: element.display_name ? element.display_name : element.name, value: element.display_name ? element.display_name : element.name, label: element.display_name ? element.display_name : element.name})
            ));
            this.setState({master_products: data.products, product_name_rows});
        })
        .catch(error => {
            console.log(error);
            
        });
    }

    handleProductSelection = (product) => {
        this.setState({selected_product: product, current_rows: []});
    }

    fetchSourcesFilter = () => {
        WarehouseService.getWarehouseList(0, 999, "", "name", "asc")
        .then((data) => {
            console.log(data);
            let source_names = [];
            let master_source = [];
            if(data && data.warehouse.length > 0){
                source_names = source_names.concat(data.warehouse.map((w) => (
                    <MenuItem key={w.id} value={w.id}>{w.name}</MenuItem>
                )));
                master_source = master_source.concat(data.warehouse);
            }
            this.setState({master_source, source_names, selected_source : ""});  
        })
        .catch(error => {
            console.log(error);
            
        });
    }

    handleSourceSelection = (e) => {
        this.setState({selected_source: e.target.value, current_rows: []});
    }

    generateReport = (e) => {
        this.fetchData();
    }

    handleChangeStartDate = (date) => {
        console.log(date);
        this.setState({
            startdate: date,
        });
    }

    handleChangeEndDate = (date) => {
        this.setState({
            enddate: date,
        });
    }

    exportReport = (e) => {
        let {data, startdate, enddate, selected_source, master_source, selected_product} = this.state;
        this.setState({exporting: true});
        if(data.opening){
            const wb = XLSX.utils.book_new();
            let sheetname = "Opening Stock";
            let source = master_source.filter((m) => m.id === selected_source)[0];
            let exportData = [["Product", selected_product.name, "Warehouse", source.name]];
            exportData.push([]);
            exportData.push(['Date', 'Opening', 'Closing']);

            let txn_date = moment(startdate).startOf('day');
            let opening = (data.opening && data.opening.opening_qty) || 0;
            let closing = 0;
            while(txn_date.diff(moment(enddate).startOf('day'), 'days') <= 0){
                let daily = data.daily_summary.filter(daily => daily.txn_date === moment(txn_date).format(format_without_time));

                if(daily.length === 1){
                    closing = opening + daily[0].inward_qty - daily[0].outward_qty;
                } else {
                    closing = opening;
                }

                let r = [ moment(txn_date).format(format_fancy_notime), opening, closing];
                exportData.push(r);
                opening = closing;
                txn_date.add(1, 'days');
            }

            const wsAll = XLSX.utils.aoa_to_sheet(exportData);
            XLSX.utils.book_append_sheet(wb, wsAll, sheetname );
            XLSX.writeFile(wb, `Inventory summary Warehouse ${source.name} - ${selected_product.name}.xlsx`);
        } else {
            this.props.showSnackBar('Nothing to export', 'error');
        }
        this.setState({exporting: false});
    } 

    fetchData = () => {
        this.setState({loading: true});
        let { startdate, enddate, selected_product, selected_source } = this.state;
        let rows = [];
        let products = !selected_product || selected_product.id === "-1" ? null : selected_product.id;
        let source_id = selected_source === "-1" ? null : selected_source;

        WarehouseService.getInventoryOpeningReport(moment(startdate).format(format_without_time), moment(enddate).format(format_without_time), products, source_id)
        .then((data) => {
            console.log(data);
            this.setState({data});

            if(data.opening){
                let txn_date = moment(startdate).startOf('day');
                let opening = (data.opening && data.opening.opening_qty) || 0;
                let closing = 0;
                let index = 1;
                while(txn_date.diff(moment(enddate).startOf('day'), 'days') <= 0){
                    let daily = data.daily_summary.filter(daily => daily.txn_date === moment(txn_date).format(format_without_time));

                    if(daily.length === 1){
                        closing = opening + daily[0].inward_qty - daily[0].outward_qty;
                    } else {
                        closing = opening;
                    }
                    rows.push(
                            <TransactionDetails
                                key={index} 
                                txn_date={moment(txn_date)} 
                                opening_qty={opening}
                                closing_qty={closing}
                                {...this.props} />);
                    opening = closing;
                    index++;
                    txn_date.add(1, 'days');
                }

                this.setState({
                    current_rows: rows
                });
            }
            this.setState({loading: false});
        })
        .catch(error => {
            console.log(error);
            this.setState({loading: false});
        });
    }
    
    render() {
        let classes = this.props.classes;
        let { loading, startdate, enddate, selected_product, selected_source, exporting } = this.state;
        return (
                <div className="Home" style={{marginTop: 32}}>
                    <Fade
                        in={loading}
                        style={{
                            transitionDelay: loading ? '10ms' : '0ms'
                        }}
                        unmountOnExit
                        >
                        <CircularProgress style={{position: "fixed", top: "50%", left: "50%", zIndex: 10}}/>
                    </Fade>
                    <div>
                        <div style={{marginBottom: 80}}>
                            <Paper className={classes.root} style={{width: "100%", paddingLeft: "5px", paddingRight: "5px"}}>
                                <Grid container alignItems="flex-end" justify="flex-start">
                                    <Grid item xs={12} lg={2}  style={{zIndex: 5}}>
                                        <FormControl variant="outlined" className={classes.formControl} style={{ float: "left"}}>
                                            <InputLabel
                                                ref={ref => {
                                                this.InputLabelRef = ref;
                                                }}
                                                htmlFor="outlined-warehouse-simple"
                                            >
                                                Warehouse
                                            </InputLabel>
                                            <Select
                                                value={this.state.selected_source}
                                                onChange={this.handleSourceSelection}
                                                input={
                                                <OutlinedInput
                                                    labelWidth={50}
                                                    name="Warehouse"
                                                    id="outlined-source-simple"
                                                />
                                                }
                                            >
                                                {this.state.source_names}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={3}  style={{zIndex: 5, paddingBottom: 3}}>
                                        {/* <FormControl variant="outlined" className={classes.formControl} style={{ float: "left"}}> */}
                                            <AutoCompleteSelection
                                                placeHolder="Product"
                                                onChange={this.handleProductSelection}
                                                name="Product"
                                                isMulti={false}
                                                value={[this.state.selected_product]}
                                                options={this.state.product_name_rows}/>
                                        {/* </FormControl> */}
                                    </Grid>
                                    <Grid item xs={12} lg={5}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <DatePicker
                                                disableToolbar
                                                variant="dialog"
                                                inputVariant="outlined"
                                                margin="normal"
                                                label="From"
                                                value={startdate}
                                                onChange={this.handleChangeStartDate}
                                                format='DD MMM YYYY'
                                                maxDate={enddate}
                                                className={classes.formControl}
                                                style={{float: "left"}}
                                            />
                                            <DatePicker
                                                disableToolbar
                                                variant="dialog"
                                                inputVariant="outlined"
                                                margin="normal"
                                                label="To"
                                                minDate={startdate}
                                                value={enddate}
                                                onChange={this.handleChangeEndDate}
                                                maxDate={moment()}
                                                format='DD MMM YYYY'
                                                className={classes.formControl}
                                                style={{float: "left"}}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item xs={12} lg={2}>
                                        <Button 
                                            disabled={!selected_product.id || !selected_source}
                                            variant="contained" 
                                            size="large" 
                                            color="primary" 
                                            style={{marginBottom: 16}}
                                            onClick={this.generateReport}>Generate Report</Button>
                                    </Grid>
                                </Grid>
                                <EnhancedTableToolbar title={""} exportReport={this.exportReport} showProgress={exporting}/>
                                <div className={classes.tableWrapper}>
                                    <Table className={classes.table} stickyHeader size="small" style={{textAlign: 'justify'}}>
                                        <EnhancedTableHead
                                            order={this.state.order}
                                            orderBy={this.state.orderBy}
                                            onRequestSort={() => {}}
                                            rows ={this.state.columns} />
                                                <TableBody>
                                                    {this.state.current_rows}
                                                </TableBody>
                                    </Table>
                                </div>
                            </Paper>
                        </div>
                    </div>
                </div>
        );
    }
}

class TransactionDetails extends Component {

    render(){
      const {txn_date, opening_qty, closing_qty} = this.props;
        return (
            <TableRow key={txn_date}>
                <TableCell component="th" scope="row" align="center" padding='none'>
                    <Typography variant="subtitle2">{getTimeInIST(txn_date).format(format_fancy_notime)}</Typography>
                </TableCell>
                {/* <TableCell align="center"  padding='none'>{}</TableCell> */}
                <TableCell align="center"  padding='none'><Typography variant="subtitle2">{opening_qty}</Typography></TableCell>
                <TableCell align="center"  padding='none'><Typography variant="subtitle2">{closing_qty}</Typography></TableCell>
            </TableRow>
        );
    }
}

export default withStyles(styles)(OpeningStockReport);